/**
 * @param {string} link
 * @returns {boolean}
 */
const isAllowed = link =>
    link && link.startsWith(`${document.location.protocol}//${document.location.host}`)/* && !/faq(\/|\.html)?$/.test(link)*/;

/**
 * @param {HTMLButtonElement|HTMLAnchorElement|Node} button
 */
export const backButton = button => {
    if (isAllowed(document.referrer) && history.length > 0) {
        if (button.tagName === 'A') {
            button.href = document.referrer;
        }
        button.addEventListener('click', e =>
            e.ctrlKey || e.preventDefault() || history.back()
        );
        button.removeAttribute('tabindex');
    }
};
